module.exports = __webpack_public_path__ + "static/media/painel.3cf4b00b.jpg";